import { HiMiniPaintBrush } from "react-icons/hi2";
// import { FaShapes } from "react-icons/fa6";
// import { IoText } from "react-icons/io5";
import { FaCircle } from "react-icons/fa6";
import SizeSlider from "./SizeSlider";

const Toolbar = ({ color, onColorClick, brush, setBrush, onBrushClick }) => {
  return (
    <div className='canvas-toolbar'>
      <div className='brush-size-slider'>
        <SizeSlider 
          value={brush.size}
          onChange={(newSize) => setBrush({...brush, size: newSize})}
        />
      </div>
      <section>
          <HiMiniPaintBrush 
            onClick={onBrushClick}
          />
          <FaCircle
            style={{ color: color }}
            onClick={onColorClick}
          />
        {/* <article>
          <FaShapes />
          Shape
        </article>
        <article>
          <IoText />
          Text
        </article> */}
      </section>

      
    </div>
  )
}

export default Toolbar